import React from 'react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

const TotalsCard = ({ company, totals }) => {
  const { subtotal = 0, excludedValue = 0, discount = 0, shipping = 0, assembly = 0, total = 0 } = totals || {};

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '100px 1fr',
        gap: '10px',
        marginTop: '6mm',
        pageBreakInside: 'avoid',
        breakInside: 'avoid'
      }}
    >
      <div
        style={{
          background: COLORS.primary,
          borderRadius: RADIUS.card,
          minHeight: '90px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: COLORS.card,
          fontSize: '12px',
          fontWeight: 700,
          textAlign: 'center',
          padding: '8px'
        }}
      >
        {(company && company.logo) ? (
          <img src={company.logo} alt={company.name} style={{ maxWidth: '100%', maxHeight: '100%' }} />
        ) : (
          <div>{company && company.name ? company.name : 'LOGO'}</div>
        )}
      </div>

      <div
        style={{
          background: COLORS.card,
          border: `1px solid ${COLORS.line}`,
          borderRadius: RADIUS.card,
          padding: '10px 14px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '4px'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '11px', fontWeight: 600, color: COLORS.textSecondary, letterSpacing: '0.5px' }}>
            SUBTOTAL
          </span>
          <span style={{ fontSize: '12px', fontWeight: 600, color: COLORS.textPrimary }}>
            {formatCurrency(subtotal)}
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '11px', fontWeight: 600, color: COLORS.textSecondary, letterSpacing: '0.5px' }}>
            (-) ITENS NÃO INCLUSOS
          </span>
          <span style={{ fontSize: '12px', fontWeight: 600, color: COLORS.textPrimary }}>
            {excludedValue ? `- ${formatCurrency(excludedValue)}` : '-'}
          </span>
        </div>
        {discount > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '11px', fontWeight: 600, color: COLORS.textSecondary, letterSpacing: '0.5px' }}>
              (-) DESCONTO
            </span>
            <span style={{ fontSize: '12px', fontWeight: 600, color: COLORS.textPrimary }}>
              {`- ${formatCurrency(discount)}`}
            </span>
          </div>
        )}
        {shipping > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '11px', fontWeight: 600, color: COLORS.textSecondary, letterSpacing: '0.5px' }}>
              (+) FRETE
            </span>
            <span style={{ fontSize: '12px', fontWeight: 600, color: COLORS.textPrimary }}>
              {`+ ${formatCurrency(shipping)}`}
            </span>
          </div>
        )}
        {assembly > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '11px', fontWeight: 600, color: COLORS.textSecondary, letterSpacing: '0.5px' }}>
              (+) MONTAGEM
            </span>
            <span style={{ fontSize: '12px', fontWeight: 600, color: COLORS.textPrimary }}>
              {`+ ${formatCurrency(assembly)}`}
            </span>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: `1px solid ${COLORS.line}`,
            paddingTop: '6px',
            marginTop: '4px'
          }}
        >
          <span style={{ ...TYPOGRAPHY.total, color: COLORS.textPrimary }}>
            TOTAL
          </span>
          <span style={{ ...TYPOGRAPHY.total, color: COLORS.primary }}>
            {formatCurrency(total)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TotalsCard;
